/**
 * Canonical timezone-abbreviation formatter shared by ActionSchedule.vue's
 * scheduled-notification template, CallMessagePreview.vue's preview render,
 * and CallSettings's MessageTemplateHelper chip-preview values.
 *
 * moment.format("z") returns a named abbreviation when one exists (e.g. "EST", "IST")
 * and a numeric offset otherwise (e.g. "+0530", "-0330", "+05:30"). Numeric offsets
 * get a "GMT" prefix so the contact-facing string is always anchored.
 */
export function formatTimezoneAbbr(abbreviation: string): string {
	if (!/[a-zA-Z]/.test(abbreviation)) {
		return `GMT${abbreviation}`;
	}
	return abbreviation;
}
